import React from "react";
import {
  Users,
  Trophy,
  MapPin,
  CalendarDays,
  Target,
  Globe,
} from "lucide-react";

const iconMap = {
  Users,
  Trophy,
  MapPin,
  CalendarDays,
  Target,
  Globe,
};

function DetailIcon({ name }) {
  const Icon = iconMap[name] || Globe;
  return <Icon className="w-5 h-5 text-[#FF6600]" />;
}

export function FundraiserDetails({ details = [] }) {
  if (!details || details.length === 0) {
    return null;
  }

  return (
    <section className="bg-white py-12">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-lg p-6 md:p-8">
          <div className="flex flex-wrap justify-center gap-6 md:gap-8">
            {details.map((detail, index) => (
              <div key={index} className="flex items-start gap-3 min-w-[150px]">
                <div className="w-10 h-10 shrink-0 rounded-full bg-orange-50 flex items-center justify-center">
                  <DetailIcon name={detail.icon} />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-wide text-gray-500 font-medium">
                    {detail.label}
                  </p>
                  <p className="text-sm font-semibold text-gray-800 mt-1">
                    {detail.value}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
